import { makeImmutable } from "../core";
export class PProductTypePackagingFeeChoice {
    constructor(params) {
        this.localizationProvider = params.localizationProvider;
        this.domain = params.domain;
        this.depositIcon = params.depositIcon;
        makeImmutable(this);
    }
    get id() {
        return this.domain.id;
    }
    get name() {
        return this.domain.name.value;
    }
    get unitPrice() {
        return this.domain.price.isZero
            ? null
            : ` (${this.localizationProvider.formatPrice(this.domain.price)})`;
    }
}
